import { SearchIcon, CrossIcon } from '@shared/assets/icons';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { Input } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import React from 'react';

interface InputSearchProps {
  changeValue?: (value: string) => void;
  searchHandler?: () => void;
  clearHandler?: () => void;
  searchValue?: string;
  placeholder?: string;
  isDisabled?: boolean;
}

const InputSearch: React.FC<InputSearchProps> = ({
  changeValue,
  searchHandler,
  clearHandler,
  searchValue,
  placeholder = 'Поиск',
  isDisabled,
}) => {
  const hasValue = !!searchValue;
  const handleIconClick = isDisabled ? undefined : hasValue ? clearHandler : searchHandler ?? clearHandler;

  return (
    <div {...stylex.props(styles.base)} data-testid="input-search">
      <UnstyledButton {...stylex.props(styles.iconButton)} onClick={handleIconClick}>
        <i {...stylex.props(styles.searchIcon, hasValue && styles.hidden)} data-testid="search-icon">
          <SearchIcon />
        </i>
        <i
          {...stylex.props(styles.crossIcon, !hasValue && styles.hidden)}
          data-testid="cross-icon"
          aria-hidden={!hasValue}
        >
          <CrossIcon />
        </i>
      </UnstyledButton>
      <Input
        changeFunction={changeValue}
        value={searchValue}
        settings={{ width: '100%' }}
        size="small"
        placeholder={placeholder}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default InputSearch;
